"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedirect = void 0;
const constants_1 = require("../contants/constants");
const productionRoutes_1 = require("../route/productionRoutes");
const WORDPRESS_REDIRECT_ROUTES = ['_direct'];
/**
 * Return the redirect URL if any.
 * @param {URL} url
 * @param {Route | null} route
 * @param apiDomain
 */
function getRedirect(url, route, apiDomain, wordpressDomain = constants_1.NOOM_WEB_DOMAIN, country) {
    // If we don't match any routes proxy the word press site.
    // TODO(George): Remove the shouldRedirectToWordpress method once WP is ready to recieve all noom.com direct traffic
    if (!route || shouldRedirectToWordpress(route, country)) {
        return { proxyUrl: `${wordpressDomain}${url.pathname}${url.search}` };
    }
    // If we match a route and its a redirect, generate the redirect URL.
    if (route.redirect) {
        let pathname = route.redirect.pathname || url.pathname;
        // Add a leading slash if pathname omits it.
        if (!pathname.startsWith('/'))
            pathname = `/${pathname}`;
        let hostname = url.hostname;
        if (route.redirect.hostname === productionRoutes_1.RedirectHost.BACKEND_API_DOMAIN) {
            hostname = apiDomain;
        }
        return {
            redirectUrl: `${url.protocol}//${hostname}${pathname}${url.search}`,
        };
    }
    // disable redirects when working on localhost
    const noomEnv = process.env.NOOM_ENV || 'local';
    const isTrailingSlashRedirectEnabled = !['local', 'development'].includes(noomEnv);
    // Redirect to the same path with an appended trailing slash if its missing
    // and allowed for the route.
    if (isTrailingSlashRedirectEnabled &&
        route.redirectOnMissingTrailingSlash &&
        !url.pathname.endsWith('/')) {
        return {
            redirectUrl: `${url.origin}${url.pathname}/${url.search}${url.hash}`,
        };
    }
    return null;
}
exports.getRedirect = getRedirect;
function shouldRedirectToWordpress(route, country) {
    var _a, _b, _c, _d;
    // check the AWS param flag
    if (process.env.WORDPRESS_REDIRECT_ENABLED !== 'true') {
        return false;
    }
    // check the country
    if (!country || country !== 'US') {
        return false;
    }
    // check the route id
    if (!((_a = route.context) === null || _a === void 0 ? void 0 : _a.route_id) ||
        !WORDPRESS_REDIRECT_ROUTES.includes((_b = route.context) === null || _b === void 0 ? void 0 : _b.route_id)) {
        return false;
    }
    // check the route language
    if (((_c = route.context) === null || _c === void 0 ? void 0 : _c.language_code) && route.context.language_code !== 'en') {
        return false;
    }
    // check the context type
    if (!((_d = route.context) === null || _d === void 0 ? void 0 : _d.context_type) ||
        route.context.context_type !== 'landing') {
        return false;
    }
    return true;
}
//# sourceMappingURL=urls.js.map